module.exports = __webpack_public_path__ + "static/img/4.1dafc73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/cooperation/4.png
// module id = jS4t
// module chunks = 3